<template>
  <div class="user_info" :style="`background-color:${this.$colors.sky_blue_1}`">
    <v-btn icon color="white" style="position: absolute; top: .5em; right: .5em; font-size: 20px" @click="closeScreen">
      <LATIcon icon="times" color="white"></LATIcon>
    </v-btn>
    <v-row>
      <v-col cols="8" style="text-align: left; display: flex; flex-direction: column; justify-content: center">
        <div style="display: flex; align-items: center;  margin-bottom: 8px;">
          <span class="welcome">Welcome back {{ name }}</span>
        </div>

        <div class="progress">
          <v-progress-circular
              :rotate="-90"
              :size="45"
              :width="5"
              :value="percentage"
              color="white"
          >
            {{ completed_procedures }}
          </v-progress-circular>
          <span style="margin-left: 4px">
            out of {{ procedures }} procedures completed
          </span>

          <v-btn @click="exitCockpit" x-small color="white" class="exitbtn">
            <span class="bluetext">Exit {{aircraftConfig.name}}</span>
            <LATIcon icon="right-to-bracket" style="margin-left: .5em" :color="$colors.blue_deep"></LATIcon>
          </v-btn>
        </div>

      </v-col>
      <v-col cols="4" style="text-align: right">
        <div class="avatar-container">
          <v-avatar :color="color" size="112" style="border: 3px solid white">
            <v-img src="../assets/images/cpt-balu.jpeg" alt="Cpt. Balu" v-if="isCptBalu"/>
            <span class="white--text text-h3" v-else>{{ initials }}</span>
          </v-avatar>
        </div>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import {aircraftConfig, settings} from "../config";
import LATIcon from "./Icon/LATIcon";

export default {
  name: "UserInfo",
  components: {LATIcon},
  props: ['aircraft', 'procedures'],
  $emit: ['close-screen'],
  data() {
    return {
      color: 'rgb(13, 71, 161)',
    }
  },
  computed: {
    name() {
      return this.$store.state.user
    },
    settings(){
      return settings;
    },
    aircraftConfig(){
      return aircraftConfig.getConfig();
    },
    completed_procedures() {
      return this.$store.state.completed_procedures.filter(p => p.aircraft === this.aircraft).length
    },
    initials() {
      if (this.name) {
        return `${this.name[0].toUpperCase()}`
      } else {
        return "U"
      }

    },
    percentage() {
      return (this.completed_procedures / this.procedures * 100).toFixed(0);
    },
    isCptBalu() {
      return this.$store.state.user === 'Cpt. Balu';
    }
  },
  methods: {
    exitCockpit() {
      this.$router.push('/cockpits')
    },
    closeScreen() {
      this.$emit('close-screen')
    }
  }
}
</script>

<style scoped lang="less">

@import "../assets/lufthansacolors";

.user_info {
  padding: 2em;
  color: white;
  position: relative;
}

.welcome {
  font-size: 24pt;
  font-weight: bold;
  margin-right: .5em;
}

.avatar-container {
  display: flex;
  flex-direction: column;
  align-items: end;
}

.exitbtn{
  margin-left: 20px;
}

.bluetext{
  color: @lh-blue_deep !important;
}

</style>